import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { selectGroupGuid, useAppSelector } from '../../slices/commonSelectors';
import { toast } from 'react-toastify';
import { icsIncidentLocationsKeys } from './icsIncidentLocation.queryKeys';
import {
  CreateIcsIncidentLocationBody,
  IcsIncidentLocation,
} from './icsIncidentLocation.types';
import { internalLayerVersionsKeys } from 'hooks/internalLayerVersion/queryKeys';
import { parseError } from 'hooks/shared/error';

export const useCreateLocation = () => {
  const queryClient = useQueryClient();
  const groupGuid = useAppSelector(selectGroupGuid);

  return useMutation({
    mutationFn: async (location: CreateIcsIncidentLocationBody) => {
      const response = await axios.post<IcsIncidentLocation>(
        config.apiGateway.ics_locations,
        {
          ...location,
          groupGuid,
        }
      );
      return response.data;
    },
    onSuccess: (data) => {
      toast.success(`Location "${data.name}" created successfully`);
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: icsIncidentLocationsKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: internalLayerVersionsKeys.all(),
      });
    },
  });
};
